import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import _ from "lodash";
import {
  showSpinner,
  closeSpinner,
  modal,
  alert,
  confirm,
} from "../modules/Dialogs";
import { CDN, sessionExpired } from "../config/GeneralConfig";
import { toScreen } from "../modules/Routing";
import PropTypes from "prop-types";
import withNavigate from "./withNavigate";
import moment from "moment-timezone";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import Pagination from "./Pagination";
import RefundDetails from "./RefundDetails";
import DriverPenalty from "./DriverPenalty";
import { Tooltip } from "react-tooltip";
import DefaultImage from "../../img/app/default-Image.webp";

import {
  getIssueResolutionsCount,
  getretrieveDriverPayIssueResolutions,
  getretrieveDriverPenaltiesIssueResolutions,
  getretrieveRefundIssueResolutions,
  getretrieveImageIssueResolutions,
  imagesBlockingDecision,
  getretrieveRefundIssueResolutionsDetails,
  getretrieveDriverPenaltiesIssueResolutionsDetails,
  getretrieveDriverPayIssueResolutionsDetails,
} from "../modules/IssueAndResolution";
import { getConversation } from "../modules/MessageManager";
import DriverPayEligibility from "./DriverPayEligibility";
import {
  getSafariCompatibleBoxSx,
  getSafariCompatibleDrawerSx,
} from "../modules/DrawerUtils";
import Popup from "./Popup";

const VALID_TABS = ["refund", "driverPenalties", "driverPayEligibility", "flaggedImages"];

const IssuesResolution = ({ userDetails, navigate }) => {
  const [urlSearchParams, setUrlSearchParams] = useSearchParams();

  const _paramSearch = urlSearchParams.get("search") || "";
  const _paramTab = VALID_TABS.includes(urlSearchParams.get("tab"))
    ? urlSearchParams.get("tab")
    : "refund";

  const isInitialMount = useRef(true);

  const [state, setState] = React.useState({
    right: false,
  });
  const [currentView, setCurrentView] = useState(null);
  const [selectedIssueResolution, setSelectedIssueResolution] = useState(null);
  const [selectedRefundIssueResolutionDetails, setSelectedRefundIssueResolutionDetails] = useState(null);
  const [selectedDriverPenaltiesIssueResolutionDetails, setSelectedDriverPenaltiesIssueResolutionDetails] = useState(null);
  const [selectedDriverPayIssueResolutionDetails, setSelectedDriverPayIssueResolutionDetails] = useState(null);
  const [statusFilter, setStatusFilter] = useState("allStatus");
  const [searchValue, setSearchValue] = useState(_paramSearch || null);
  const [search, setSearch] = useState(_paramSearch);
  const [filter, setFilter] = useState(
    _paramSearch ? null : (window.history.state?.usr?.selectedFilter ?? "all")
  );
  const [conversationDetails, setConversationDetails] = useState([]);
  const [count, setCount] = useState(0);
  const [jobTypeFilter, setJobTypeFilter] = useState("all");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [cancelledStartDate, setCancelledStartDate] = useState(null);
  const [cancelledEndDate, setCancelledEndDate] = useState(null);
  const [scheduledStartDate, setScheduledStartDate] = useState(null);
  const [scheduledEndDate, setScheduledEndDate] = useState(null);
  const [flaggedStartDate, setFlaggedStartDate] = useState(null);
  const [flaggedEndDate, setFlaggedEndDate] = useState(null);
  const [pageSize, setPageSize] = useState(15);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [inputValue, setInputValue] = useState(1);
  const [sort, setSort] = useState("dateSorter=-1");
  const [activeTab, setActiveTab] = useState(_paramTab);
  const [imageTypeFilter, setImageTypeFilter] = useState("all");
  const [imageStatusFilter, setImageStatusFilter] = useState("all");
  const [activeFilters, setActiveFilters] = useState({
    refund: null,
    driverPenalties: null,
    flaggedImages: null,
  });
  const [filterCount, setFilterCount] = useState({
    refundsCount: 0,
    driverPenaltiesCount: 0,
    driverPayEligibilityCount: 0,
    flaggedImagesCount: 0,
  });
  const [eligibilityFilter, setEligibilityFilter] = useState("all");
  const [flaggedImagesFilter, setFlaggedImagesFilter] = useState("all");
  const [issueResolutions, setIssueResolutions] = useState([]);
  const [selectedCheckbox, setSelectedCheckbox] = useState([]);

  const fetchFilterCount = () => {
    showSpinner();
    getIssueResolutionsCount(
      { userType: "user" },
      handleFilterCount_done,
      userDetails.jwttoken
    );
  };

  const handleFilterCount_done = (resStatus, responseString, resJson) => {
    if (resStatus === 401) {
      modal(sessionExpired);
      toScreen(false, navigate, "/logout");
    } else if (resStatus === "400") {
      alert(responseString);
    } else if (resStatus === 200) {
      setFilterCount({
        refundsCount: resJson?.refundsCount,
        driverPenaltiesCount: resJson?.driverPenaltiesCount,
        driverPayEligibilityCount: resJson?.driverPayEligibilityCount,
        flaggedImagesCount: resJson?.flaggedByAIImages,
      });
    }
  };

  const getConversations = (convPropsArgument) => {
    const requasterShortId = convPropsArgument?.userDetails?.shortId || "Admin";

    const queryParams = {
      receiverShortId: convPropsArgument?.driverDetails?.shortId,
      receiverId: convPropsArgument?.driverDetails?._id,
      requasterShortId,
      page: 1,
      pageSize: 100000,
    };

    getConversation(queryParams, getConversation_done, userDetails?.jwttoken);
  };

  const getConversation_done = (resStatus, responseString, resJson) => {
    closeSpinner();

    if (resStatus === 401) {
      return modal(responseString, "401 Unauthorized", () =>
        window.history.back()
      );
    }

    if (resStatus === 400) {
      return modal(responseString, "Something went wrong!", () =>
        window.history.back()
      );
    }

    if (resStatus === 200) {
      setConversationDetails(resJson?.data);
    }
  };

  // Toggle drawer function
  const toggleDrawer =
    (anchor, open, view = null, issueResolution = null) =>
    (event) => {
      // if (
      //   event.type === "keydown" &&
      //   (event.key === "Tab" || event.key === "Shift")
      // ) {
      //   return;
      // }

      setState({ ...state, [anchor]: open });

      if (open) {
        setCurrentView(view);
        if (issueResolution) {
          setSelectedIssueResolution(issueResolution);
          // Call getDriverPayIssueResolutionsDetails when opening drawer with issueResolution
          if (view === "details" && activeTab === "driverPayEligibility") {
            getDriverPayIssueResolutionsDetails(event, issueResolution?._id);
          }
          if (view === "details" && activeTab === "driverPenalties") {
            getDriverPenaltiesIssueResolutionsDetails(event, issueResolution?._id);
          }
          if (view === "details" && activeTab === "refund") {
            getRefundIssueResolutionsDetails(event, issueResolution?._id);
          }
        } else {
          setSelectedIssueResolution(null);
        }
        getConversations(issueResolution);
      }
    };

  useEffect(() => {
    setInputValue(page);
  }, [page]);

  const searchIssueAndResolution = useCallback(() => {
    setSearch(searchValue);
    setFilter(searchValue === "" ? "all" : null);
    setPage(1);
  }, [searchValue]);

  const clearSearch = () => {
    setSearchValue("");
    setSearch("");
    setFilter("all");
    setPage(1);
  };

  const sortIssueResolutions = (event, field) => {
    if (event) event.preventDefault();

    const sortFields = {
      firstnameSorter: { asc: "firstnameSorter=1", desc: "firstnameSorter=-1" },
      dateSorter: { asc: "dateSorter=1", desc: "dateSorter=-1" },
      reasonSorter: { asc: "reasonSorter=1", desc: "reasonSorter=-1" },
      cancelledOnSorter: {
        asc: "cancelledOnSorter=1",
        desc: "cancelledOnSorter=-1",
      },
      scheduledForSorter: {
        asc: "scheduledForSorter=1",
        desc: "scheduledForSorter=-1",
      },
      cancelledOnSorter: {
        asc: "cancelledOnSorter=1",
        desc: "cancelledOnSorter=-1",
      },
      postedOnSorter: { asc: "postedOnSorter=1", desc: "postedOnSorter=-1" },
      cancellationRateSorter: {
        asc: "cancellationRateSorter=1",
        desc: "cancellationRateSorter=-1",
      },
      job: { asc: "job=1", desc: "job=-1" },
      bookedFor: { asc: "bookedFor=1", desc: "bookedFor=-1" },
      bookedOnSorter: { asc: "bookedOnSorter=1", desc: "bookedOnSorter=-1" },
      scheduledForSorter: {
        asc: "scheduledForSorter=1",
        desc: "scheduledForSorter=-1",
      },
      amountSorter: { asc: "amountSorter=1", desc: "amountSorter=-1" },
      requestedOnSorter: {
        asc: "requestedOnSorter=1",
        desc: "requestedOnSorter=-1",
      },
      statusSorter: { asc: "statusSorter=1", desc: "statusSorter=-1" },
      startDate: { asc: "startDate=1", desc: "startDate=-1" },
      uses: { asc: "uses=1", desc: "uses=-1" },
      endDate: { asc: "endDate=1", desc: "endDate=-1" },
    };

    const currentSort = sortFields[field];
    if (!currentSort) return;

    const newSort =
      sort === currentSort.asc ? currentSort.desc : currentSort.asc;

    setSort(newSort);
    setPage(1);
  };

  const formatDateForAPI = (date) => {
    return date ? moment(date).format("YYYY-MM-DD") : null;
  };

  const getRefundIssueResolutions = () => {
    const dateLowerRange = formatDateForAPI(startDate);
    const dateUpperRange = formatDateForAPI(endDate);

    if ((startDate && !endDate) || (!startDate && endDate)) {
      console.warn("Both start and end dates are required.");
      return;
    }

    const queryParams = {
      search,
      jobType: jobTypeFilter !== "all" ? jobTypeFilter : undefined,
      refund: statusFilter !== "allStatus" ? statusFilter : undefined,
      dateLowerRange,
      dateUpperRange,
      filter,
      sort,
      page,
      limit: pageSize, // Add limit to the query params
    };
    // Remove undefined values
    Object.keys(queryParams).forEach(
      (key) => queryParams[key] === undefined && delete queryParams[key]
    );

    showSpinner();
    getretrieveRefundIssueResolutions(
      queryParams,
      getRefundIssueResolutions_done,
      userDetails.jwttoken
    );
  };

  const getRefundIssueResolutions_done = (
    resStatus,
    responseString,
    resJson
  ) => {
    closeSpinner();

    if (resStatus === 401) {
      modal(sessionExpired);
      toScreen(false, navigate, "/logout");
    } else if (resStatus === "400") {
      setIssueResolutions([]);
      alert(responseString);
    } else if (resStatus === 200) {
      setTotalPages(Math.ceil(resJson?.totalRecords / pageSize));
      setIssueResolutions(resJson?.data || []);
      setCount(resJson);

      // Update filter counts if available
      if (resJson?.filterCounts) {
        setFilterCount(resJson.filterCounts);
      }
    }
  };

  const getRefundIssueResolutionsDetails = (event, cancellationDetailsId) => {
    if (event) event.preventDefault();
    const queryParams = {
      cancellationDetailsId: cancellationDetailsId,
    };

    showSpinner();
    getretrieveRefundIssueResolutionsDetails(
      queryParams,
      getRefundIssueResolutionsDetails_done,
      userDetails.jwttoken
    );
  };

  const getRefundIssueResolutionsDetails_done = (
    resStatus,
    responseString,
    resJson
  ) => {
    closeSpinner();

    if (resStatus === 401) {
      modal(sessionExpired);
      toScreen(false, navigate, "/logout");
    } else if (resStatus === "400") {
      setSelectedRefundIssueResolutionDetails(null);
      alert(responseString);
    } else if (resStatus === 200) {
      setSelectedRefundIssueResolutionDetails(resJson?.data || []);
    }
  };

  const getDriverPenaltiesIssueResolutionsDetails = (event, penaltyActivityId) => {
    if (event) event.preventDefault();
    const queryParams = {
      penaltyActivityId: penaltyActivityId,
    };

    showSpinner();
    getretrieveDriverPenaltiesIssueResolutionsDetails(
      queryParams,
      getDriverPenaltiesIssueResolutionsDetails_done,
      userDetails.jwttoken
    );
  };

  const getDriverPenaltiesIssueResolutionsDetails_done = (
    resStatus,
    responseString,
    resJson
  ) => {
    closeSpinner();

    if (resStatus === 401) {
      modal(sessionExpired);
      toScreen(false, navigate, "/logout");
    } else if (resStatus === "400") {
      setSelectedDriverPenaltiesIssueResolutionDetails(null);
      alert(responseString);
    } else if (resStatus === 200) {
      setSelectedDriverPenaltiesIssueResolutionDetails(resJson?.data || []);
    }
  };

  // Enhanced API call for driver penalties
  const getDriverPenaltiesIssueResolutions = () => {
    const dateLowerRange = formatDateForAPI(cancelledStartDate);
    const dateUpperRange = formatDateForAPI(cancelledEndDate);
    const scheduledDateLowerRange = formatDateForAPI(scheduledStartDate);
    const scheduledDateUpperRange = formatDateForAPI(scheduledEndDate);

    if (
      (cancelledStartDate && !cancelledEndDate) ||
      (!cancelledStartDate && cancelledEndDate)
    ) {
      console.warn("Both cancelled start and end dates are required.");
      return;
    }

    if (
      (scheduledStartDate && !scheduledEndDate) ||
      (!scheduledStartDate && scheduledEndDate)
    ) {
      console.warn("Both scheduled start and end dates are required.");
      return;
    }
    const queryParams = {
      search,
      jobType: jobTypeFilter !== "all" ? jobTypeFilter : undefined,
      penalty: statusFilter !== "allStatus" ? statusFilter : undefined,
      dateLowerRange,
      dateUpperRange,
      scheduledDateLowerRange,
      scheduledDateUpperRange,
      filter,
      sort,
      page,
      limit: pageSize,
    };

    Object.keys(queryParams).forEach(
      (key) => queryParams[key] === undefined && delete queryParams[key]
    );

    showSpinner();
    getretrieveDriverPenaltiesIssueResolutions(
      queryParams,
      getDriverPenaltiesIssueResolutions_done,
      userDetails.jwttoken
    );
  };

  const getDriverPenaltiesIssueResolutions_done = (
    resStatus,
    responseString,
    resJson
  ) => {
    closeSpinner();

    if (resStatus === 401) {
      modal(sessionExpired);
      toScreen(false, navigate, "/logout");
    } else if (resStatus === "400") {
      setIssueResolutions([]);
      alert(responseString);
    } else if (resStatus === 200) {
      setTotalPages(Math.ceil(resJson?.totalRecords / pageSize));
      setIssueResolutions(resJson?.data || []);
      setCount(resJson);

      // Update filter counts if available
      if (resJson?.filterCounts) {
        setFilterCount(resJson.filterCounts);
      }
    }
  };

  const getDriverPayIssueResolutions = () => {
    const dateLowerRange = formatDateForAPI(cancelledStartDate);
    const dateUpperRange = formatDateForAPI(cancelledEndDate);

    if (
      (cancelledStartDate && !cancelledEndDate) ||
      (!cancelledStartDate && cancelledEndDate)
    ) {
      console.warn("Both cancelled start and end dates are required.");
      return;
    }

    if (
      (scheduledStartDate && !scheduledEndDate) ||
      (!scheduledStartDate && scheduledEndDate)
    ) {
      console.warn("Both scheduled start and end dates are required.");
      return;
    }
    const queryParams = {
      search,
      jobType: jobTypeFilter !== "all" ? jobTypeFilter : undefined,
      eligibility: eligibilityFilter !== "all" ? eligibilityFilter : undefined,
      dateLowerRange,
      dateUpperRange,
      filter,
      sort,
      page,
      limit: pageSize,
    };

    Object.keys(queryParams).forEach(
      (key) => queryParams[key] === undefined && delete queryParams[key]
    );

    showSpinner();
    getretrieveDriverPayIssueResolutions(
      queryParams,
      getDriverPayIssueResolutions_done,
      userDetails.jwttoken
    );
  };

  const getDriverPayIssueResolutions_done = (
    resStatus,
    responseString,
    resJson
  ) => {
    closeSpinner();

    if (resStatus === 401) {
      modal(sessionExpired);
      toScreen(false, navigate, "/logout");
    } else if (resStatus === "400") {
      setIssueResolutions([]);
      alert(responseString);
    } else if (resStatus === 200) {
      setTotalPages(Math.ceil(resJson?.totalRecords / pageSize));
      setIssueResolutions(resJson?.data || []);
      setCount(resJson);

      // Update filter counts if available
      if (resJson?.filterCounts) {
        setFilterCount(resJson.filterCounts);
      }
    }
  };


  const getDriverPayIssueResolutionsDetails = (event, cancellationDetailsId) => {
    if (event) event.preventDefault();
    const queryParams = {
      cancellationDetailsId: cancellationDetailsId,
    };

    showSpinner();
    getretrieveDriverPayIssueResolutionsDetails(
      queryParams,
      getDriverPayIssueResolutionsDetails_done,
      userDetails.jwttoken
    );
  };

  const getDriverPayIssueResolutionsDetails_done = (
    resStatus,
    responseString,
    resJson
  ) => {
    closeSpinner();

    if (resStatus === 401) {
      modal(sessionExpired);
      toScreen(false, navigate, "/logout");
    } else if (resStatus === "400") {
      setSelectedDriverPayIssueResolutionDetails(null);
      alert(responseString);
    } else if (resStatus === 200) {
      setSelectedDriverPayIssueResolutionDetails(resJson?.data || []);
    }
  };


  const getImageIssueResolutions = () => {
    const dateLowerRange = formatDateForAPI(flaggedStartDate);
    const dateUpperRange = formatDateForAPI(flaggedEndDate);
    if (
      (flaggedStartDate && !flaggedEndDate) ||
      (!flaggedStartDate && flaggedEndDate)
    ) {
      console.warn("Both flagged start and end dates are required.");
      return;
    }
    const queryParams = {
      search,
      imageType: imageTypeFilter !== "all" ? imageTypeFilter : undefined,
      imageStatus: imageStatusFilter !== "all" ? imageStatusFilter : undefined,
      dateLowerRange,
      dateUpperRange,
      filter,
      sort,
      page,
      limit: pageSize,
    };

    Object.keys(queryParams).forEach(
      (key) => queryParams[key] === undefined && delete queryParams[key]
    );

    showSpinner();
    getretrieveImageIssueResolutions(
      queryParams,
      getImageIssueResolutions_done,
      userDetails.jwttoken
    );
  };

  const getImageIssueResolutions_done = (
    resStatus,
    responseString,
    resJson
  ) => {
    closeSpinner();

    if (resStatus === 401) {
      modal(sessionExpired);
      toScreen(false, navigate, "/logout");
    } else if (resStatus === "400") {
      setIssueResolutions([]);
      alert(responseString);
    } else if (resStatus === 200) {
      setTotalPages(Math.ceil(resJson?.totalRecords / pageSize));
      setIssueResolutions(resJson?.data || []);
      setCount(resJson);

      // Update filter counts if available
      if (resJson?.filterCounts) {
        setFilterCount(resJson.filterCounts);
      }
    }
  };

  const handleImagesBlockingDecision = useCallback(
    async ({ originalRecordId, imageType, isBlocked }) => {
      const imagesBlockingDecision_done = (
        resStatus,
        responseString,
        resJson
      ) => {
        closeSpinner();

        if (resStatus === 200) {
          modal(" Blocking Decision has been resolved");
          getImageIssueResolutions();
        } else if (resStatus === 400) {
          modal(responseString);
        } else {
          modal(responseString || "Something went wrong!");
        }
      };

      const payload = {
        originalRecordId,
        imageType,
        isBlocked,
      };
      try {
        showSpinner();
        imagesBlockingDecision(
          payload,
          imagesBlockingDecision_done,
          userDetails?.jwttoken
        );
      } catch (error) {
        closeSpinner();
        modal("Failed to process blocking decision");
      }
    },
    [getImageIssueResolutions, userDetails?.jwttoken]
  );

  const handleBlockAllowConfirmation = useCallback(
    ({ originalRecordId, imageType, isBlocked }) => {
      const action = isBlocked
        ? "Are you sure you want to block this image?"
        : "Are you sure you want to allow this image? ";

      confirm(action, false, "Cancel", "Confirm", () => {
        handleImagesBlockingDecision({
          originalRecordId,
          imageType,
          isBlocked,
        });
      });
    },
    [handleImagesBlockingDecision]
  );
  // Fetch data when filters change
  useEffect(() => {
    if (activeTab === "refund") {
      getRefundIssueResolutions();
    } else if (activeTab === "driverPenalties") {
      getDriverPenaltiesIssueResolutions();
    } else if (activeTab === "driverPayEligibility") {
      getDriverPayIssueResolutions();
    } else if (activeTab === "flaggedImages") {
      getImageIssueResolutions();
    }
  }, [
    activeTab,
    search,
    sort,
    page,
    pageSize,
    statusFilter,
    eligibilityFilter,
    flaggedImagesFilter,
    imageTypeFilter,
    imageStatusFilter,
    startDate,
    endDate,
    cancelledStartDate,
    cancelledEndDate,
    scheduledStartDate,
    scheduledEndDate,
    flaggedStartDate,
    flaggedEndDate,
  ]);

  // Reset tab-specific filters when switching tabs (skip on initial mount to preserve URL params)
  // Search is intentionally preserved across tab switches
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    setStatusFilter("allStatus");
    setEligibilityFilter("all");
    setFlaggedImagesFilter("all");
    setImageTypeFilter("all");
    setImageStatusFilter("all");
    setPage(1);
    setSort("dateSorter=-1");
  }, [activeTab]);

  // Keep URL query params in sync with active tab and search
  // Flagged Images tab has no search, so omit the search param for it
  useEffect(() => {
    const params = { tab: activeTab };
    if (search && activeTab !== "flaggedImages") params.search = search;
    setUrlSearchParams(params, { replace: true });
  }, [activeTab, search]);

  useEffect(() => {
    fetchFilterCount();
  }, []);

  const renderIssueResolution = (issueResolution, index) => {
    const statusMap = {
      exempt: {
        label: "Waived",
        badge: "badge-secondary",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-circle-off lucide-icon h-3 w-3"
          >
            <path d="m2 2 20 20"></path>
            <path d="M8.35 2.69A10 10 0 0 1 21.3 15.65"></path>
            <path d="M19.08 19.08A10 10 0 1 1 4.92 4.92"></path>
          </svg>
        ),
      },
      "not exempt": {
        label: "Applied",
        badge: "badge-danger",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-circle-arrow-up lucide-icon h-3 w-3"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <path d="m16 12-4-4-4 4"></path>
            <path d="M12 16V8"></path>
          </svg>
        ),
      },
      pending: {
        label: "Pending",
        badge: "badge-warning",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-clock h-3 w-3"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        ),
      },
      approved: {
        label: "Approved",
        badge: "badge-success",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-check h-3 w-3"
          >
            <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
            <path d="m9 11 3 3L22 4"></path>
          </svg>
        ),
      },
      rejected: {
        label: "Rejected",
        badge: "badge-danger",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-x h-3 w-3"
          >
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        ),
      },
      closed: {
        label: "Cancelled by client",
        badge: "badge-danger",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <path d="m15 9-6 6"></path>
            <path d="m9 9 6 6"></path>
          </svg>
        ),
        icon1: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#000000"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 16v-4"></path>
            <path d="M12 8h.01"></path>
          </svg>
        ),
      },
    };

    const status =
      issueResolution?.status ||
      issueResolution?.refund ||
      issueResolution?.jobDetails?.status;
    const statusData = statusMap[status?.toLowerCase()];

    const getJobTypeDisplay = (jobType) => {
      const jobTypeMap = {
        getitems: "Get items",
        housemove: "House move",
        senditems: "Send items",
        wasteDisposal: "Waste Disposal",
      };
      return jobTypeMap[jobType] || jobType;
    };

    const cancellationRatePercentage =
      issueResolution?.driverDetails?.cancellationRate > 0
        ? `(${(
            (issueResolution?.driverDetails?.cancellationRate /
              issueResolution?.driverDetails?.bookings) *
            100
          )?.toFixed(2)}%)`
        : null;

    if (activeTab === "refund") {
      return (
        <div className={`c-list-entry align-items-center`} key={index}>
          <div className="c-list-entry__mavname">
            <b
              className="text-capitalize u-color-teal u-cursor-pointer"
              onClick={() => toScreen(false, navigate, `/client/${issueResolution?.userDetails?.shortId}`)}
            >
              {`${
                issueResolution?.userDetails?.firstname
                  ? issueResolution.userDetails.firstname
                  : ""
              } ${
                issueResolution?.userDetails?.lastname
                  ? issueResolution.userDetails.lastname
                  : ""
              }`}
            </b>
          </div>
          <div className="c-list-entry__rating">
            <span>
              {" "}
              {getJobTypeDisplay(issueResolution?.jobDetails?.jobType)}
            </span>
            <br />
            <span
              className="u-color-teal u-cursor-pointer"
              onClick={() => toScreen(false, navigate, `/job/${issueResolution?.jobDetails?.shortId}`)}
            >
              {issueResolution?.jobDetails?.shortId}
            </span>
          </div>{" "}
          <div className="c-list-entry__rating">
            <span className="u-before-icon text-capitalize">
              <strong> &nbsp;&nbsp; £</strong>
              {issueResolution?.jobDetails?.bookedFor / 100}
            </span>
          </div>
          <div className="c-list-entry__reason overflow-hidden text-wrap ">
       
              {issueResolution?.cancellationDetails?.reason}
           
          </div>
          <div className="c-list-entry__status">
            {statusData && (
              <span className={`badge text-capitalize ${statusData?.badge}`}>
                {statusData?.icon}
                <span className="ml-1">{statusData?.label}</span>
              </span>
            )}
          </div>
          <div className="c-list-entry__startDate">
            {moment(issueResolution?.cancellationDetails?.cancelledOn)
              ?.tz("Europe/London")?.format("DD-MM-YYYY")}{" "}
            <br />
            {moment(issueResolution?.cancellationDetails?.cancelledOn)
              ?.tz("Europe/London")?.format("HH:mm ")}
          </div>
          <div className="c-list-entry__uses">
            {["right"].map((anchor) => (
              <React.Fragment key={anchor}>
                <Button
                  className="btn btn-sm btn-primary"
                  onClick={toggleDrawer(
                    anchor,
                    true,
                    "details",
                    issueResolution
                  )}
                >
                  Details
                </Button>
                <Drawer
                  anchor={anchor}
                  open={state[anchor]}
                  onClose={toggleDrawer(anchor, false)}
                  ModalProps={{
                    BackdropProps: {
                      style: { backgroundColor: "rgba(0, 0, 0, 0.1)" },
                    },
                  }}
                  sx={getSafariCompatibleDrawerSx(600)}
                >
                  {RefundDetailsPage(anchor)}
                </Drawer>
              </React.Fragment>
            ))}
          </div>
        </div>
      );
    }

    if (activeTab === "driverPenalties") {
      return (
        <div className={`c-list-entry align-items-center`} key={index}>
          <div className="c-list-entry__reason text-capitalize">
            <span
              className="u-color-teal u-cursor-pointer"
              onClick={() => toScreen(false, navigate, `/mav/${issueResolution?.driverDetails?.shortId}`)}
            >
              {`${
                issueResolution?.driverDetails?.firstname
                  ? issueResolution.driverDetails.firstname
                  : ""
              } ${
                issueResolution?.driverDetails?.lastname
                  ? issueResolution.driverDetails.lastname
                  : ""
              }`}
            </span>
          </div>
          <div className="c-list-entry__mavname" >
            {issueResolution?.driverDetails?.cancellationRate}/
            {issueResolution?.driverDetails?.bookings} bookings <br />
            <span className="text-xs">{cancellationRatePercentage}</span>
          </div>
          <div className="c-list-entry__reason overflow-hidden text-wrap">
            <span
              className="u-before-icon text-capitalize"
            >
              &nbsp;&nbsp;{issueResolution?.cancellationDetails?.reason}
            </span>

          </div>
          <div className="c-list-entry__rating" >
            {moment(issueResolution?.cancellationDetails?.cancelledOn)
              ?.tz("Europe/London")?.format("DD-MM-YYYY")}{" "}
            <br />
            {moment(issueResolution?.cancellationDetails?.cancelledOn)
              ?.tz("Europe/London")?.format("HH:mm A")}{" "}
          </div>
          <div className="c-list-entry__reviews" >
            {statusData && (
              <span className={`badge ${statusData?.badge}`}>
                {statusData?.icon}
                <span className="ml-1">{statusData?.label}</span>
              </span>
            )}
          </div>
          <div className="c-list-entry__reviews" >
            <span>
              {" "}
              {getJobTypeDisplay(issueResolution?.jobDetails?.jobType)}
            </span>{" "}
            <br />{" "}
            <span
              className="u-color-teal u-cursor-pointer"
              onClick={() => toScreen(false, navigate, `/job/${issueResolution?.jobDetails?.shortId}`)}
            >
              {issueResolution?.jobDetails?.shortId}
            </span>
          </div>

          <div className="c-list-entry__jobdate" >
            {issueResolution?.cancellationDetails?.wasJobPaid === true ? (
              <div>
                <strong> &nbsp;&nbsp; £</strong>
                {issueResolution?.jobDetails?.bookedFor / 100 || 0}
              </div>
            ) : (
              <div>-</div>
            )}
          </div>

          <div className="c-list-entry__jobdate" >
            {issueResolution?.cancellationDetails?.wasJobPaid === true ? (
              <div>
                {moment(issueResolution?.jobDetails?.bookedOn)
                  ?.tz("Europe/London")?.format("DD-MM-YYYY")}{" "}
                <br />
                {moment(issueResolution?.jobDetails?.bookedOn)
                  ?.tz("Europe/London")?.format("HH:mm")}{" "}
              </div>
            ) : (
              <div>-</div>
            )}
          </div>
          <div className="c-list-entry__jobdate" >
            {moment(issueResolution?.jobDetails?.scheduledFor)
              ?.utc()
              ?.format("DD-MM-YYYY")}{" "}
            <br />
            {moment(issueResolution?.jobDetails?.scheduledFor)
              ?.utc()
              ?.format("HH:mm")}
          </div>

          <div className="c-list-entry__uses ">
            {["right"].map((anchor) => (
              <React.Fragment key={anchor}>
                <Button
                  className="btn btn-sm btn-primary"
                  onClick={toggleDrawer(
                    anchor,
                    true,
                    "details",
                    issueResolution
                  )}
                >
                  Details
                </Button>
                <Drawer
                  anchor={anchor}
                  open={state[anchor]}
                  onClose={toggleDrawer(anchor, false)}
                  ModalProps={{
                    BackdropProps: {
                      style: { backgroundColor: "rgba(0, 0, 0, 0.1)" },
                    },
                  }}
                  sx={getSafariCompatibleDrawerSx(600)}
                >
                  {DriverPenaltyPage(anchor)}
                </Drawer>
              </React.Fragment>
            ))}
          </div>
        </div>
      );
    }

    if (activeTab === "driverPayEligibility") {
      return (
        <div className={`c-list-entry align-items-center`} key={index}>
          <div className="c-list-entry__reason text-capitalize">
            <span
              className="u-color-teal u-cursor-pointer"
              onClick={() => toScreen(false, navigate, `/mav/${issueResolution?.driverDetails?.shortId}`)}
            >
              {`${
                issueResolution?.driverDetails?.firstname
                  ? issueResolution.driverDetails.firstname
                  : ""
              } ${
                issueResolution?.driverDetails?.lastname
                  ? issueResolution.driverDetails.lastname
                  : ""
              }`}
            </span>
          </div>
          <div className="c-list-entry__mavname ">
            <span
              className={` badge ${
                issueResolution?.jobDetails?.mavPaymentDetails?.verdict ===
                "approved"
                  ? "badge-success"
                  : issueResolution?.jobDetails?.mavPaymentDetails?.verdict ===
                    "rejected"
                  ? "badge-gray"
                  : issueResolution?.jobDetails?.mavPaymentDetails?.verdict ===
                    "pending"
                  ? "badge-warning"
                  : "badge-secondary"
              }`}
            >
              {issueResolution?.jobDetails?.mavPaymentDetails?.verdict ===
                "approved" && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-circle-check-big lucide-icon h-3 w-3"
                  aria-hidden="true"
                >
                  <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                  <path d="m9 11 3 3L22 4"></path>
                </svg>
              )}

              {issueResolution?.jobDetails?.mavPaymentDetails?.verdict ===
                "rejected" && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-circle-minus lucide-icon h-3 w-3"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M8 12h8"></path>
                </svg>
              )}

              {issueResolution?.jobDetails?.mavPaymentDetails?.verdict ===
                "pending" && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-clock lucide-icon h-3 w-3"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
              )}

              {issueResolution?.jobDetails?.mavPaymentDetails?.verdict ===
              "approved"
                ? "Gets Paid"
                : issueResolution?.jobDetails?.mavPaymentDetails?.verdict ===
                  "rejected"
                ? "Not eligible"
                : issueResolution?.jobDetails?.mavPaymentDetails?.verdict ===
                  "pending"
                ? "Pending"
                : "-"}
            </span>
          </div>

          <div className="c-list-entry__mavname text-capitalize">
            <span>
              {getJobTypeDisplay(issueResolution?.jobDetails?.jobType)}
            </span>{" "}
            <br />{" "}
            <span
              className=" u-color-teal u-cursor-pointer"
              onClick={() => toScreen(false, navigate, `/job/${issueResolution?.jobDetails?.shortId}`)}
            >
              {issueResolution?.jobDetails?.shortId}
            </span>
          </div>
          <div className="c-list-entry__location ">
            {statusData && (
              <span className={`badge ${statusData?.badge}`}>
                {statusData?.icon}
                <span className="ml-1">{statusData?.label}</span>
                <span
                  className="tooltipStatus cursor-help"
                  data-tooltip-id={`tooltip-${issueResolution?._id}`}
                >
                  {statusData?.icon1}
                </span>

                <Tooltip
                  id={`tooltip-${issueResolution?._id}`}
                  className="custom-tooltip"
                  place="top"
                >
                  {issueResolution?.cancellationDetails?.reason}
                </Tooltip>
              </span>
            )}
            <br />
          </div>

          <div className="c-list-entry__jobdate">
            {moment(issueResolution?.jobDetails?.bookedOn)
                ?.tz("Europe/London")?.format("DD-MM-YYYY")}
            <br />
            <span className="text-xs text-gray-600">
              {moment(issueResolution?.jobDetails?.bookedOn)
                ?.tz("Europe/London")?.format("HH:mm")}
            </span>
          </div>

          <div className="c-list-entry__jobdate">
            {moment(issueResolution?.jobDetails?.scheduledFor)
              ?.tz("Europe/London")?.format("DD-MM-YYYY") || "-"}
            <br />
            <span className="text-xs text-gray-600">
              {moment(issueResolution?.jobDetails?.scheduledFor)
                ?.tz("Europe/London")?.format("HH:mm") || "-"}
            </span>
          </div>
          <div className="c-list-entry__jobdate">
            {moment(issueResolution?.cancellationDetails?.cancelledOn)
              ?.tz("Europe/London")?.format("DD-MM-YYYY") || "-"}
            <br />
            <span className="text-xs text-gray-600">
              {moment(issueResolution?.cancellationDetails?.cancelledOn)
                ?.tz("Europe/London")
                ?.format("HH:mm") || "-"}
            </span>
          </div>

          <div className="c-list-entry__uses ">
            {["right"].map((anchor) => (
              <React.Fragment key={anchor}>
                <Button
                  className="btn btn-sm btn-primary"
                  onClick={toggleDrawer(
                    anchor,
                    true,
                    "details",
                    issueResolution
                  )}
                >
                  Details
                </Button>
                <Drawer
                  anchor={anchor}
                  open={state[anchor]}
                  onClose={toggleDrawer(anchor, false)}
                  ModalProps={{
                    BackdropProps: {
                      style: { backgroundColor: "rgba(0, 0, 0, 0.1)" },
                    },
                  }}
                  sx={getSafariCompatibleDrawerSx(600)}
                >
                  {DriverPayEligibiltyPage(anchor)}
                </Drawer>
              </React.Fragment>
            ))}
          </div>
        </div>
      );
    }
    if (activeTab === "flaggedImages") {
      return (
        <div className={`c-list-entry align-items-center`} key={index}>
          <div className="c-list-entry__mavname">
            <b className="text-capitalize">
              {" "}
              {`${
                issueResolution?.firstname ? issueResolution.firstname : "-"
              } ${issueResolution?.lastname ? issueResolution.lastname : "-"}`}
            </b>
            <br />
            <span className="text-sm text-gray-600">
              {issueResolution?.userShortId ? issueResolution.userShortId : "-"}
            </span>
          </div>
          <div className="c-list-entry__mavname ">
            <span
              className={` badge text-sm fw-medium ${
                issueResolution?.imageType === "jobImage"
                  ? "badge-purple"
                  : issueResolution?.imageType === "profileImage"
                  ? "badge-blue"
                  : "badge-gray"
              }`}
            >
              {issueResolution?.imageType === "jobImage"
                ? "Job Image"
                : issueResolution?.imageType === "profileImage"
                ? "Profile Image"
                : "-"}
            </span>
            <span
              onClick={(e) =>
                toScreen(e, navigate, "/job/" + issueResolution?.jobShortId)
              }
              className="text-sm text-blue fw-medium d-block mt-4 cursor-pointer"
            >
              {issueResolution?.jobShortId}
            </span>
          </div>
          <div className="c-list-entry__mavname text-capitalize d-flex justify-content-center align-items-center overflow-visible">
            <Popup
              imageUrl={`${CDN}/${issueResolution?.imageKey}`}
              trigger={
                <img
                  src={`${CDN}/${issueResolution?.imageKey}`}
                  alt="job image"
                  className="job-image mb-0 w-100 h-100 object-fit-cover"
                  onError={(e) => {
                    e.target.src = DefaultImage;
                  }}
                />
              }
              content={
                <img
                  src={`${CDN}/${issueResolution?.imageKey}`}
                  alt="job image preview"
                  className="popup-preview-image"
                  onError={(e) => {
                    e.target.src = DefaultImage;
                  }}
                />
              }
            />
          </div>
          <div className="c-list-entry__location c-list-filter">
            <span className="d-flex align-items-center text-md text-orange fw-medium g-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="h-14 w-14 text-orange"
                aria-hidden="true"
              >
                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
                <path d="M12 9v4"></path>
                <path d="M12 17h.01"></path>
              </svg>
              Flagged for:
            </span>
            <span className="text-md text-orange fw-medium d-block text-wrap word-wrap word-break-word">
              {issueResolution?.flaggingCategory || "No Reason available."}
            </span>
          </div>
          <div className="c-list-entry__refunds c-list-filter">
            {moment(issueResolution?.flaggingDate)
                ?.tz("Europe/London")?.format("DD-MM-YYYY") || "-"}
            <br />
            <span className="text-xs text-gray-600">
              {moment(issueResolution?.flaggingDate)?.tz("Europe/London")?.format("HH:mm") ||
                "-"}
            </span>
          </div>
          <div className="d-flex justify-content-center align-items-center g-4">
            {/* CASE 1: First time → isBlocked is undefined → show BOTH buttons */}
            {issueResolution?.blockDetails?.isBlocked === undefined && (
              <>
                <button
                  type="button"
                  className="c-btn c-btn--red c-btn--small"
                  onClick={() =>
                    handleBlockAllowConfirmation({
                      originalRecordId: issueResolution?.originalRecordId,
                      imageType:
                        issueResolution?.imageType === "jobImage"
                          ? "job"
                          : "profile",
                      isBlocked: true,
                    })
                  }
                >
                  Block
                </button>
                <button
                  type="button"
                  className="c-btn c-btn--green c-btn--small me-0"
                  onClick={() =>
                    handleBlockAllowConfirmation({
                      originalRecordId: issueResolution?.originalRecordId,
                      imageType:
                        issueResolution?.imageType === "jobImage"
                          ? "job"
                          : "profile",
                      isBlocked: false,
                    })
                  }
                >
                  Allow
                </button>
              </>
            )}

            {/* CASE 2: If isBlocked is false → user previously clicked ALLOW → show only BLOCK button */}
            {issueResolution?.blockDetails?.isBlocked === false && (
              <button
                type="button"
                className="c-btn c-btn--red c-btn--small"
                onClick={() =>
                  handleBlockAllowConfirmation({
                    originalRecordId: issueResolution?.originalRecordId,
                    imageType:
                      issueResolution?.imageType === "jobImage"
                        ? "job"
                        : "profile",
                    isBlocked: true, // switching to block
                  })
                }
              >
                Block
              </button>
            )}

            {/* CASE 3: If isBlocked is true → user previously clicked BLOCK → show only ALLOW button */}
            {issueResolution?.blockDetails?.isBlocked === true && (
              <button
                type="button"
                className="c-btn c-btn--green c-btn--small me-0"
                onClick={() =>
                  handleBlockAllowConfirmation({
                    originalRecordId: issueResolution?.originalRecordId,
                    imageType:
                      issueResolution?.imageType === "jobImage"
                        ? "job"
                        : "profile",
                    isBlocked: false, // switching to allow
                  })
                }
              >
                Allow
              </button>
            )}
          </div>

          {/* <div className="c-list-entry__uses ">
          </div> */}
        </div>
      );
    }
  };

  const RefundDetailsPage = (anchor) => (
    <Box
      sx={getSafariCompatibleBoxSx()}
      role="presentation"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <RefundDetails
        view={currentView}
        issueResolution={selectedRefundIssueResolutionDetails}
        onClose={toggleDrawer(anchor, false)}
        selectedIssueResolution={selectedRefundIssueResolutionDetails}
        userDetails={userDetails}
        conversationDetails={conversationDetails}
        theCallBackFunc={getRefundIssueResolutions}
        getConversations={getConversations}
      />
    </Box>
  );

  const DriverPenaltyPage = (anchor) => (
    <Box
      sx={getSafariCompatibleBoxSx()}
      role="presentation"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <DriverPenalty
        view={currentView}
        issueResolution={selectedDriverPenaltiesIssueResolutionDetails}
        onClose={toggleDrawer(anchor, false)}
        selectedIssueResolution={selectedDriverPenaltiesIssueResolutionDetails}
        userDetails={userDetails}
        theCallBackFunc={getDriverPenaltiesIssueResolutions}
        conversationDetails={conversationDetails}
        getConversations={getConversations}
      />
    </Box>
  );

  const DriverPayEligibiltyPage = (anchor) => (
    <Box
      sx={getSafariCompatibleBoxSx()}
      role="presentation"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <DriverPayEligibility
        view={currentView}
        issueResolution={selectedDriverPayIssueResolutionDetails}
        onClose={toggleDrawer(anchor, false)}
        selectedIssueResolution={selectedDriverPayIssueResolutionDetails}
        userDetails={userDetails}
        theCallBackFunc={getDriverPayIssueResolutions}
        conversationDetails={conversationDetails}
        getConversations={getConversations}
      />
    </Box>
  );

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    const inputValue = type === "checkbox" ? checked : value;
    setPage(1);
    if (name === "search") {
      setSearchValue(inputValue);
    } else if (name === "jobType") {
      setJobTypeFilter(inputValue);
    } else if (name === "filter") {
      setSearch("");
      setSearchValue(null);
      setFilter(inputValue);
    } else if (name === "penalty") {
      setStatusFilter(inputValue);
    } else if (name === "refund") {
      setStatusFilter(inputValue);
    } else if (name === "eligibility") {
      setEligibilityFilter(inputValue);
    } else if (name === "flaggedImages") {
      setFlaggedImagesFilter(inputValue);
    } else if (name === "imageType") {
      setImageTypeFilter(inputValue);
    } else if (name === "imageStatus") {
      setImageStatusFilter(inputValue);
      setFlaggedImagesFilter(inputValue);
    }
  };

  const handleDeleteSelected = () => {
    // Placeholder for delete functionality
    alert("Delete functionality not yet implemented.");
  };

  const getSortClass = useCallback(
    (key) => {
      if (sort === `${key}=1`) {
        return "c-list-filter__button c-list-filter__button--icon-up";
      } else if (sort === `${key}=-1`) {
        return "c-list-filter__button c-list-filter__button--icon-down";
      }
      return "c-list-filter__button c-list-filter__button--faded";
    },
    [sort]
  );

  const getJobTypeDisplay = (jobType) => {
    const jobTypeMap = {
      getitems: "Get items",
      housemove: "House move",
      senditems: "Send items",
      wasteDisposal: "Waste Disposal",
    };
    return jobTypeMap[jobType] || jobType;
  };

  const renderColumnHeaders = () => {
    return (
      (activeTab === "refund" && (
        <div className="c-list-entry c-list-entry__header align-items-center">
          <div className="c-list-entry__mavname c-list-filter">
            <button
              className={getSortClass("firstnameSorter")}
              onClick={(e) => sortIssueResolutions(e, "firstnameSorter")}
            >
              Client
            </button>
          </div>
          <div className="c-list-entry__rating c-list-filter">
            <button
              className={getSortClass("job")}
              // onClick={(e) => sortIssueResolutions(e, "job")}
            >
              Job
            </button>
          </div>
          <div className="c-list-entry__rating c-list-filter">
            <button
              className={getSortClass("amountSorter")}
              onClick={(e) => sortIssueResolutions(e, "amountSorter")}
            >
              Amount
            </button>
          </div>
          <div className="c-list-entry__reason c-list-filter">
            <button
              className={getSortClass("reasonSorter")}
              onClick={(e) => sortIssueResolutions(e, "reasonSorter")}
            >
              Reason
            </button>
          </div>
          <div className="c-list-entry__status c-list-filter">
            <button
              className={getSortClass("statusSorter")}
              onClick={(e) => sortIssueResolutions(e, "statusSorter")}
            >
              Status
            </button>
          </div>
          <div className="c-list-entry__startDate c-list-filter">
            <button
              className={getSortClass("requestedOnSorter")}
              onClick={(e) => sortIssueResolutions(e, "requestedOnSorter")}
            >
              Requested On
            </button>
          </div>
          <div className="c-list-entry__uses c-list-filter">
            <button className="c-list-filter__button--faded">Actions</button>
          </div>
        </div>
      )) ||
      (activeTab === "driverPenalties" && (
        <div className="c-list-entry c-list-entry__header align-items-center">
          <div className="c-list-entry__reason c-list-filter">
            <button
              className={getSortClass("firstnameSorter")}
              onClick={(e) => sortIssueResolutions(e, "firstnameSorter")}
            >
              Driver
            </button>
          </div>
          <div className="c-list-entry__mavname c-list-filter" >
            <button
              className={getSortClass("cancellationRateSorter")}
              onClick={(e) => sortIssueResolutions(e, "cancellationRateSorter")}
            >
              Cancellations
            </button>
          </div>
          <div className="c-list-entry__reason c-list-filter">
            <button
              className={getSortClass("reasonSorter")}
              onClick={(e) => sortIssueResolutions(e, "reasonSorter")}
            >
              Reason
            </button>
          </div>
          <div className="c-list-entry__rating c-list-filter" >
            <button
              className={getSortClass("cancelledOnSorter")}
              onClick={(e) => sortIssueResolutions(e, "cancelledOnSorter")}
            >
              Cancelled On
            </button>
          </div>
          <div className="c-list-entry__reviews c-list-filter">
            <button
              className={getSortClass("statusSorter")}
              onClick={(e) => sortIssueResolutions(e, "statusSorter")}
            >
              Status
            </button>
          </div>
          <div className="c-list-entry__reviews c-list-filter" >
            <button
              className={getSortClass("job")}
              // onClick={(e) => sortIssueResolutions(e, "job")}
            >
              Job
            </button>
          </div>
          <div className="c-list-entry__jobdate c-list-filter">
            <button
              className={getSortClass("bookedFor")}
              onClick={(e) => sortIssueResolutions(e, "bookedFor")}
            >
              Booked For
            </button>
          </div>
          <div className="c-list-entry__jobdate c-list-filter" >
            <button
              className={getSortClass("bookedOnSorter")}
              onClick={(e) => sortIssueResolutions(e, "bookedOnSorter")}
            >
              Booked On
            </button>
          </div>
          <div className="c-list-entry__jobdate c-list-filter" >
            <button
              className={getSortClass("scheduledForSorter")}
              onClick={(e) => sortIssueResolutions(e, "scheduledForSorter")}
            >
              Scheduled for
            </button>
          </div>
          <div className="c-list-entry__uses c-list-filter" >
            <button className="c-list-filter__button--faded">Actions</button>
          </div>
        </div>
      )) ||
      (activeTab === "driverPayEligibility" && (
        <div className="c-list-entry c-list-entry__header align-items-center">
          <div className="c-list-entry__reason c-list-filter">
            <button
              className={getSortClass("firstnameSorter")}
              onClick={(e) => sortIssueResolutions(e, "firstnameSorter")}
            >
              Driver
            </button>
          </div>
          <div className="c-list-entry__mavname c-list-filter">
            <button
              className={getSortClass("statusSorter")}
              onClick={(e) => sortIssueResolutions(e, "statusSorter")}
            >
              Eligibility Status{" "}
            </button>
          </div>
          <div className="c-list-entry__mavname c-list-filter">
            <button
            // className={getSortClass("eligibleOnSorter")}
            // onClick={(e) => sortIssueResolutions(e, "eligibleOnSorter")}
            >
              Job
            </button>
          </div>
          <div className="c-list-entry__location c-list-filter">
            <button
            // className={getSortClass("statusqSorter")}
            // onClick={(e) => sortIssueResolutions(e, "statuqsSorter")}
            >
              Job status
            </button>
          </div>
          <div className="c-list-entry__jobdate c-list-filter">
            <button
              className={getSortClass("postedOnSorter")}
              onClick={(e) => sortIssueResolutions(e, "postedOnSorter")}
            >
              Posted on
            </button>
          </div>
          <div className="c-list-entry__jobdate c-list-filter">
            <button
              className={getSortClass("scheduledForSorter")}
              onClick={(e) => sortIssueResolutions(e, "scheduledForSorter")}
            >
              Scheduled for
            </button>
          </div>
          <div className="c-list-entry__jobdate c-list-filter">
            <button
              className={getSortClass("cancelledOnSorter")}
              onClick={(e) => sortIssueResolutions(e, "cancelledOnSorter")}
            >
              Cancelled on
            </button>
          </div>
          <div className="c-list-entry__uses c-list-filter">
            <button className="c-list-filter__button--faded">Actions</button>
          </div>
        </div>
      )) ||
      (activeTab === "flaggedImages" && (
        <div className="c-list-entry c-list-entry__header align-items-center">
          <div className="c-list-entry__mavname c-list-filter">
            <button
              className={getSortClass("firstnameSorter")}
              onClick={(e) => sortIssueResolutions(e, "firstnameSorter")}
            >
              User
            </button>
          </div>
          <div className="c-list-entry__mavname c-list-filter">
            <button
              className={getSortClass("statusSorter")}
              onClick={(e) => sortIssueResolutions(e, "statusSorter")}
            >
              Image Type
            </button>
          </div>
          <div className="c-list-entry__mavname c-list-filter">
            <button
            // className={getSortClass("eligibleOnSorter")}
            // onClick={(e) => sortIssueResolutions(e, "eligibleOnSorter")}
            >
              Image
            </button>
          </div>
          <div className="c-list-entry__location c-list-filter">
            <button
            // className={getSortClass("statusqSorter")}
            // onClick={(e) => sortIssueResolutions(e, "statuqsSorter")}
            >
              Reason
            </button>
          </div>
          <div className="c-list-entry__refunds c-list-filter">
            <button
              className={getSortClass("dateSorter")}
              onClick={(e) => sortIssueResolutions(e, "dateSorter")}
            >
              Date
            </button>
          </div>

          {/* <div className="d-flex justify-content-center align-items-center g-4">
            <button className="c-list-filter__button--faded">Actions</button>
          </div> */}
        </div>
      ))
    );
  };

  const renderFilterOptions = () => {
    if (activeTab === "refund") {
      return (
        <div className="l-col-100 u-padding-top-0 u-padding-bottom-0">
          <div className="filter-bar">
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="refund_all"
                name="refund"
                value="allStatus"
                onChange={handleInputChange}
                checked={statusFilter === "allStatus"}
              />
              <label htmlFor="refund_all">All</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="refund_pending"
                name="refund"
                value="pending"
                onChange={handleInputChange}
                checked={statusFilter === "pending"}
              />
              <label htmlFor="refund_pending">Pending</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="refund_approved"
                name="refund"
                value="approved"
                onChange={handleInputChange}
                checked={statusFilter === "approved"}
              />
              <label htmlFor="refund_approved">Approved</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="refund_rejected"
                name="refund"
                value="rejected"
                onChange={handleInputChange}
                checked={statusFilter === "rejected"}
              />
              <label htmlFor="refund_rejected">Rejected</label>
            </div>
          </div>
        </div>
      );
    }
    if (activeTab === "driverPayEligibility") {
      return (
        <div className="l-col-100 u-padding-top-0 u-padding-bottom-0">
          <div className="filter-bar">
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="eligibility_all"
                name="eligibility"
                value="all"
                onChange={handleInputChange}
                checked={eligibilityFilter === "all"}
              />
              <label htmlFor="eligibility_all">All</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="eligibility_pending"
                name="eligibility"
                value="pending"
                onChange={handleInputChange}
                checked={eligibilityFilter === "pending"}
              />
              <label htmlFor="eligibility_pending">Pending</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="eligibility_approved"
                name="eligibility"
                value="approved"
                onChange={handleInputChange}
                checked={eligibilityFilter === "approved"}
              />
              <label htmlFor="eligibility_approved">Gets Paid</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="eligibility_rejected"
                name="eligibility"
                value="rejected"
                onChange={handleInputChange}
                checked={eligibilityFilter === "rejected"}
              />
              <label htmlFor="eligibility_rejected">Not Eligible</label>
            </div>
          </div>
        </div>
      );
    }
    if (activeTab === "flaggedImages") {
      return (
        <div className="l-col-100 u-padding-top-0 u-padding-bottom-0">
          <div className="filter-bar">
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="flaggedImages_all"
                name="imageStatus"
                value="all"
                onChange={handleInputChange}
                checked={flaggedImagesFilter === "all"}
              />
              <label htmlFor="flaggedImages_all">All</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="flaggedImages_pending"
                name="imageStatus"
                value="pending"
                onChange={handleInputChange}
                checked={flaggedImagesFilter === "pending"}
              />
              <label htmlFor="flaggedImages_pending">Pending</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="flaggedImages_blocked"
                name="imageStatus"
                value="blocked"
                onChange={handleInputChange}
                checked={flaggedImagesFilter === "blocked"}
              />
              <label htmlFor="flaggedImages_blocked">Blocked</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="flaggedImages_allowed"
                name="imageStatus"
                value="unblocked"
                onChange={handleInputChange}
                checked={flaggedImagesFilter === "unblocked"}
              />
              <label htmlFor="flaggedImages_allowed">Allowed</label>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="l-col-100 u-padding-top-0 u-padding-bottom-0">
          <div className="filter-bar">
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="penalty_all"
                name="penalty"
                value="allStatus"
                onChange={handleInputChange}
                checked={statusFilter === "allStatus"}
              />
              <label htmlFor="penalty_all">All</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="penalty_pending"
                name="penalty"
                value="pending"
                onChange={handleInputChange}
                checked={statusFilter === "pending"}
              />
              <label htmlFor="penalty_pending">Pending</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="penalty_applied"
                name="penalty"
                value="not exempt"
                onChange={handleInputChange}
                checked={statusFilter === "not exempt"}
              />
              <label htmlFor="penalty_applied">Applied</label>
            </div>
            <div className="c-checkbox-radio-block">
              <input
                type="radio"
                id="penalty_waived"
                name="penalty"
                value="exempt"
                onChange={handleInputChange}
                checked={statusFilter === "exempt"}
              />
              <label htmlFor="penalty_waived">Waived</label>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="l-base-layout__content">
      <h1>Admin / Issues & Resolutions</h1>

      <div className="c-hr"></div>
      <div className="my-16">
        <div className="custom-tabs">
          <div
            className={`tab-item ${activeTab === "refund" ? "active" : ""}`}
            onClick={() => setActiveTab("refund")}
          >
            Refunds
            <span className="badge">{filterCount?.refundsCount || 0}</span>
          </div>
          <div
            className={`tab-item ${
              activeTab === "driverPenalties" ? "active" : ""
            }`}
            onClick={() => setActiveTab("driverPenalties")}
          >
            Driver Penalties
            <span className="badge">
              {filterCount?.driverPenaltiesCount || 0}
            </span>{" "}
          </div>
          <div
            className={`tab-item ${
              activeTab === "driverPayEligibility" ? "active" : ""
            }`}
            onClick={() => setActiveTab("driverPayEligibility")}
          >
            Driver Pay Eligibility
            <span className="badge">
              {filterCount?.driverPayEligibilityCount || 0}
            </span>{" "}
          </div>
          <div
            className={`tab-item ${
              activeTab === "flaggedImages" ? "active" : ""
            }`}
            onClick={() => setActiveTab("flaggedImages")}
          >
            Flagged Images
            <span className="badge">
              {filterCount?.flaggedImagesCount || 0}
            </span>{" "}
          </div>
        </div>
      </div>
      <div
        className={`${
          activeTab === "flaggedImages"
            ? "c-subheader-info-panel__search"
            : "c-subheader-info-panel"
        }`}
      >
        {activeTab === "refund" && (
          <div className="c-subheader-info-panel__search">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                searchIssueAndResolution();
              }}
            >
              <div className="c-search-input-wrap">
                <input
                  type="text"
                  value={searchValue || ""}
                  onChange={handleInputChange}
                  name="search"
                  placeholder="Search Refunds..."
                  className="c-subheader-info-panel__input"
                />
                {searchValue && (
                  <button
                    type="button"
                    className="c-search-clear-btn"
                    onClick={clearSearch}
                    aria-label="Clear search"
                  >
                    &times;
                  </button>
                )}
              </div>
              <button
                type="button"
                className="c-btn-outline c-btn-outline--white c-btn-outline--small"
                onClick={() =>
                  searchValue !== null && searchIssueAndResolution()
                }
              >
                Search
              </button>
            </form>
          </div>
        )}

        {activeTab === "driverPenalties" && (
          <div className="c-subheader-info-panel__search">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                searchIssueAndResolution();
              }}
            >
              <div className="c-search-input-wrap">
                <input
                  type="text"
                  value={searchValue || ""}
                  onChange={handleInputChange}
                  name="search"
                  placeholder="Search Driver Penalties..."
                  className="c-subheader-info-panel__input"
                />
                {searchValue && (
                  <button
                    type="button"
                    className="c-search-clear-btn"
                    onClick={clearSearch}
                    aria-label="Clear search"
                  >
                    &times;
                  </button>
                )}
              </div>
              <button
                type="button"
                className="c-btn-outline c-btn-outline--white c-btn-outline--small"
                onClick={() =>
                  searchValue !== null && searchIssueAndResolution()
                }
              >
                Search
              </button>
            </form>
          </div>
        )}

        {activeTab === "driverPayEligibility" && (
          <div className="c-subheader-info-panel__search">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                searchIssueAndResolution();
              }}
            >
              <div className="c-search-input-wrap">
                <input
                  type="text"
                  value={searchValue || ""}
                  onChange={handleInputChange}
                  name="search"
                  placeholder="Search Driver Pay eligibility..."
                  className="c-subheader-info-panel__input"
                />
                {searchValue && (
                  <button
                    type="button"
                    className="c-search-clear-btn"
                    onClick={clearSearch}
                    aria-label="Clear search"
                  >
                    &times;
                  </button>
                )}
              </div>
              <button
                type="button"
                className="c-btn-outline c-btn-outline--white c-btn-outline--small"
                onClick={() =>
                  searchValue !== null && searchIssueAndResolution()
                }
              >
                Search
              </button>
            </form>
          </div>
        )}
      </div>

      <div className="my-16 text-end">
        {selectedCheckbox.length > 0 && (
          <button
            type="button"
            className="c-btn c-btn--red c-btn--small mb-0"
            onClick={handleDeleteSelected}
          >
            Delete Selected
          </button>
        )}
      </div>

      <div className="l-row">
        {renderFilterOptions()}

        <div className="l-col-100" style={{ overflowX: 'auto' }}>
          <div className="c-hr u-margin-bottom-0"></div>

          {/* Column headers based on active tab */}
          {renderColumnHeaders()}

          <div>
            {issueResolutions?.length > 0 ? (
              issueResolutions?.map(renderIssueResolution)
            ) : (
              <div className="u-text-align-center u-margin-top-bottom-m u-color-red">
                No{" "}
                {activeTab === "refund"
                  ? "Refunds"
                  : activeTab === "driverPenalties"
                  ? "Driver Penalties"
                  : activeTab === "driverPayEligibility"
                  ? "Driver Pay Eligibility"
                  : "Flagged Images"}{" "}
                found.
              </div>
            )}
          </div>

          <div className="c-hr u-margin-bottom-0"></div>

          <Pagination
            pageSize={pageSize}
            totalPages={totalPages}
            page={page}
            setPage={setPage}
            inputValue={inputValue}
            setInputValue={setInputValue}
            setPageSize={setPageSize}
          />
        </div>
      </div>
    </div>
  );
};

IssuesResolution.propTypes = {
  userDetails: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
};

export default withNavigate(IssuesResolution);

